// extracted by mini-css-extract-plugin
export default {"root":"styles_root__oMX1Y","header":"styles_header__OWnVL","goBack":"styles_goBack__-E6vV","title":"styles_title__gznj+","actions":"styles_actions__2n45O"};